<template>
  <div :class="['input-wrapper', { input_error: error }, { input_disabled: disabled }]">
    <input
      :id="id"
      :value="currentValue"
      :maxlength="maxLength"
      :disabled="disabled"
      :tabindex="disabled ? -1 : 1"
      v-bind="$attrs"
      class="input__field"
      type="tel"
      placeholder=""
      @input="onInput($event.target.value, $event)"
      @focus="clearError"
    >

    <label
      v-if="label"
      :for="id"
      class="input__label autofill"
      :class="{ 'input__label-top': currentValue.length > 0 }"
    >
      {{ label }}
      <span v-if="required" class="input__label-required">*</span>
    </label>

    <span v-if="error && (errorMsg || errorMsgLocal)" class="input__error-msg">
      {{ errorMsgLocal || errorMsg }}
    </span>
    <ErrorIcon
      v-if="error && (errorMsg || errorMsgLocal)"
      class="input__error-msg-icon"
    />
  </div>
</template>

<script>
  import ErrorIcon from '@/assets/img/icons/error.svg?inline'
  import { isMd } from '@/config'

  export default {
    name: 'BaseInputTel',
    components: { ErrorIcon },
    inheritAttrs: false,
    props: {
      name: { type: String, default: '' },
      value: { type: String, default: '' },
      label: { type: String, default: '' },
      errorMsg: { type: String, default: '' },
      disabled: { type: Boolean, default: false },
      minLength: { type: Number, default: isMd ? 9 : 10 },
      maxLength: { type: Number, default: isMd ? 12 : 13 }
    },
    data () {
      return {
        currentValue: this.value,
        error: false,
        errorMsgLocal: ''
      }
    },
    computed: {
      id () {
        return `input-${this._uid}`
      },
      required () {
        return 'required' in this.$attrs && this.$attrs.required
      }
    },
    watch: {
      value (newVal) {
        this.currentValue = newVal
        if (!newVal) this.clearError()
      },
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },
    methods: {
      onInput: function (value, event) {
        // оставляем только цифры и + в начале
        if (value.charAt(0) === '+') {
          value = '+' + value.slice(1).replace(/\D/g, '')
        } else {
          value = value.replace(/\D/g, '')
        }

        // ограничение по maxlength
        if (value.length > this.maxLength) {
          value = value.slice(0, this.maxLength)
        }

        this.currentValue = value
        this.clearError()

        // **Немедленно обновляем input**, чтобы запрещённые символы не показывались
        if (event && event.target) {
          event.target.value = value
        }

        this.$emit('input', value)
      },
      onBlur: function () {
        // при уходе с поля валидируем и отправляем значение наружу
        if (this.currentValue.length < this.minLength) {
          this.error = true
          this.errorMsgLocal = 'Номер телефону повинен містити мінімум ' + this.minLength + ' символів'
        } else {
          this.clearError()
        }
        this.$emit('input', this.currentValue)
      },
      clearError: function () {
        this.error = false
        this.errorMsgLocal = ''
      }
    }
  }
</script>

<style lang="scss">
$padding-for-error: 20px;

//.service-request-page__form-input.input-wrapper input:not(:placeholder-shown) ~ label,
.service-request-page__form-input.input-wrapper input:-webkit-autofill ~ label /* <<<< Add these */
{
  display: none;
}

.service-request-page__form-input.input-wrapper input:-webkit-autofill ~ label.autofill {
  display: block;
  top: 6px;
  font-size: 10px;
  line-height: 20px;
  color: $c-gray;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px #fff inset !important;
  transition: #fff 5000s ease-in-out 0s;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
  -webkit-transition-delay: 9999s;
}

.input {
  &-wrapper {
    &:not(:placeholder-shown, :active, :focus-visible) {
      label: {
        opacity: 0;
      }
    }

    position: relative;
    min-width: 290px;

    & input:focus + .input__label,
    & textarea:focus + .input__label {
      top: 6px;
      font-size: 10px;
      line-height: 20px;
      color: $c-gray;
    }
  }

  &_disabled {
    pointer-events: none;
  }

  &__label {
    position: absolute;
    top: 19px;
    left: 20px;
    z-index: 1;
    display: inline-block;
    padding-bottom: 1em;
    font-family: NobelWGL-Book;
    font-weight: 400;
    letter-spacing: 1px;
    font-size: 16px;
    color: $c-gray-new;
    user-select: none;
    transition: all 0.2s;
    pointer-events: none;

    &-top {
      top: 6px;
      font-size: 10px;
      line-height: 20px;
      color: $c-gray;
    }

    &-required {
      color: $c-active-light;
    }
  }

  &__field {
    display: block;
    width: 100%;
    height: 56px;
    padding: 0 20px;
    padding-top: 18px;
    font-family: NobelWGL-Book;
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: 1px;
    border: 1px solid $c-gray-light;
    outline: none;
    caret-color: $c-black;
    appearance: none;
    transition: 0.3s;
    border-radius: 0;

    &:invalid {
      box-shadow: none;
    }

    &.textarea {
      min-height: 168px;
      padding-top: 20px;
      padding-bottom: 20px;
      overflow: auto;
      line-height: 1.4;
      resize: none;

      @include custom-scrollbar();
    }

    &-container {
      position: relative;

      &::after {
        // error icon
        position: absolute;
        top: 50%;
        right: 5%;
        display: inline-block;
        width: 1.5em;
        height: 1.5em;
        padding-top: 0.25em;
        color: $c-white;
        text-align: center;
        content: "!";
        background-color: $c-active;
        border-radius: 50%;
        opacity: 0;
        transition: opacity 0.3s;
        transform: translateY(-50%);
      }
    }

    @include hover {
      background-color: $gray;
    }

    &:focus {
      background-color: $c-white;
      border-color: $c-gray-new;
      box-shadow: 0 2px 10px 0 $c-shadow;
    }
  }

  &__error-msg {
    position: absolute;
    bottom: 14px;
    left: 0;
    height: 0;
    padding-right: 20px;
    font-size: 12px;
    color: $c-error;

    &-icon {
      position: absolute;
      top: 59px;
      right: 0;

      path {
        fill: $c-error;
      }

      &-top {
        top: 171px;
      }
    }
  }

  &_error {
    padding-bottom: $padding-for-error;

    .input {
      &__field {
        padding-right: 3.5em;
        border-color: $c-error;

        &-container {
          &::after {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
